import { z } from "zod"
import { useCustomer, useCustomersActions } from "@/api/customers"
import { customerFormSchema } from "./customer.schema"
import { toast } from "sonner"
import CustomerForm from "./customer.form"
import { SheetClose, SheetFooter } from "@/components/ui/sheet"
import { Button } from "@/components/ui/button"
import Loader from "@/components/layout/loader"

interface CustomerUpdateProps {
  id: string;
  onDone: () => void;
}

export default function CustomerUpdate({ id, onDone }: CustomerUpdateProps) {
  const { customer } = useCustomer(id)
  const { update } = useCustomersActions()

  const onSubmit = async (data: z.infer<typeof customerFormSchema>) => {
    await update(id, data)
    toast.success("Customer updated")
    onDone()
  }

  if (!customer) {
    return <Loader message="Loading customer..." />
  }

  return (
    <CustomerForm onSubmit={onSubmit} defaultValues={customer}>
      <SheetFooter>
        <SheetClose asChild>
          <Button variant="outline" type="button">
            Cancel
          </Button>
        </SheetClose>
        <Button type="submit">Update customer</Button>
      </SheetFooter>
    </CustomerForm>
  )
}
